import { render, staticRenderFns } from "./upgradeactive.vue?vue&type=template&id=16313633&scoped=true"
import script from "./upgradeactive.vue?vue&type=script&lang=js"
export * from "./upgradeactive.vue?vue&type=script&lang=js"
import style0 from "./upgradeactive.vue?vue&type=style&index=0&id=16313633&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16313633",
  null
  
)

export default component.exports